import { render, staticRenderFns } from "./AppHighlightsAppstoreRating.vue?vue&type=template&id=48ac9c28&"
import script from "./AppHighlightsAppstoreRating.vue?vue&type=script&lang=js&"
export * from "./AppHighlightsAppstoreRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports